import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import { isLoggedIn } from '../Login/selectors'
import loginApi from '../Login/api'
import { getNoLoggedPath } from './utils'

function ProtectedRoute({ isLoggedIn, component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props => isLoggedIn ? (
        <Component {...props} />
      ) : (
        <Redirect to={getNoLoggedPath(loginApi.retrieveHasUser())} />
      )}
    />
  )
}

ProtectedRoute.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired
}

const mapStateToPros = createStructuredSelector({ isLoggedIn })
const connector = connect(mapStateToPros)

export default connector(ProtectedRoute)
